export class PageUrls {
  static readonly ROOT: string = '/';
  static readonly HOME: string = '/dashboard';

  static readonly LOGIN: string = '/auth/login';
  static readonly LOGOUT: string = '/auth/logout';
}
